export default __webpack_public_path__ + "static/media/avatar.8c7734e6.svg";